import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User clicks 'distance away' dropdown menu on explore map on web.
 */
const logExploreMapDistanceAwayDropdownClicked = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('explore map distance away dropdown clicked', {}, callback);
};

export default logExploreMapDistanceAwayDropdownClicked;
